
export default {
    props: {
        color: {
            default: 'primary'
        },
        background: {
          default: 'white'
        },
        border: {
          default: null
        },
        disableClick: {
          default: false
        }
    }
}
